export default __webpack_public_path__ + "static/image2-95d5b5c3258788a8e4406aac35129d85.jpg";